import React from 'react';
import { MediaCaptions } from '~/ui/video-player/MediaCaptions';
import { useMediaPlayer } from '~/ui/video-player/useMediaPlayer';
import { Item, ItemDefinition, registry, RenderProps } from '../Item';
import { AUDIO } from '../itemIds';
import { useEditorStore } from '~/shell/Store';

interface Props {
  mediaUrl: string;
  subtitlesUrl?: string;
  autoPlay?: boolean;
}

export type AudioDefinition = ItemDefinition<typeof AUDIO, Props>;

export class Audio extends Item<typeof AUDIO, Props> {
  protected render({ mediaUrl, subtitlesUrl, autoPlay }: RenderProps<Props>) {
    const { contentEditable } = useEditorStore();

    useMediaPlayer(mediaUrl, 'audio', subtitlesUrl, contentEditable ? false : autoPlay);
    return <MediaCaptions />;
  }
}

registry[AUDIO] = Audio;
